<mat-tab-group (selectedTabChange)="tabClicked($event)" [(selectedIndex)]="ActiveTab" mat-stretch-tabs
    class="tab_group">
    <mat-tab label="ADD" class="tab_content" *ngIf="persistenceService.get('addDisable') == 'true'">
        <form class="global-form" (ngSubmit)="saveAppointment($event)" [formGroup]="newForm">
            <div class="flex-row">
                <mat-card appearance="outlined" class="contain_card flex-25">
                    <mat-form-field appearance="fill">

                        <mat-label>Company</mat-label>
                        <input class="global-input" matInput required readonly value="{{defaultCompany}}" formControlName="company_id" />
                    </mat-form-field>
                </mat-card>
                <mat-card appearance="outlined" class="contain_card flex-25">
                    <mat-form-field appearance="fill" class="field-full-width">

                        <mat-label>Booking No</mat-label>
                        <input class="global-input" matInput required *ngFor="let maxappointno of maxappointnos | async"
                            value="{{maxappointno.id}}" readonly id="ref_no" name="ref_no" formControlName="ref_no" />
                    </mat-form-field>
                </mat-card>
                <mat-card appearance="outlined" class="contain_card flex-25">
                    <mat-form-field appearance="fill" class="field-full-width">

                        <mat-label>Booking Date</mat-label>
                        <input class="global-input" matInput required readonly value="{{appointment.booked_on_date}}" />
                    </mat-form-field>
                </mat-card>
                <mat-card appearance="outlined" class="contain_card flex-25">
                    <mat-form-field appearance="fill" class="field-full-width">

                        <mat-label>Booking Time</mat-label>
                        <input class="global-input" matInput required readonly value="{{appointment.booked_at_time}}" />
                    </mat-form-field>
                </mat-card>
            </div>
            <mat-card appearance="outlined" class="mat_card">
                <fieldset class="field_set">
                    <legend class="legend">Visitor Details</legend>
                    <div class="flex-row">
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Visitor Name</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.visitor_name"
                                    formControlName="visitor_name" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Company Name</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.visitor_company"
                                    formControlName="visitor_company" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Address</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.address" formControlName="address" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Visitor Mobile No</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.visitor_mobile_no"
                                    formControlName="visitor_mobile_no" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                    <div class="flex-row">
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Country</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.country" formControlName="country" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>State</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.state" formControlName="state" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>City</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.city" formControlName="city" />
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>PIN</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.pin" formControlName="pin" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                </fieldset>
            </mat-card>
            <mat-card appearance="outlined" class="mat_card">
                <fieldset class="field_set">
                    <legend class="legend">Appointment Details</legend>
                    <div class="flex-row">
                        <mat-card appearance="outlined" class="contain_card flex-33">
                            <mat-form-field appearance="fill" id="selectOption">

                                <mat-label>Appointment Fixed By</mat-label>
                                <mat-select panelClass="custom-select-panel" formControlName="appointment_fixed_by" required
                                    [(ngModel)]="appointment.appointment_fixed_by">
                                    <mat-option *ngFor="let appointmentfixedby of appointmentfixedbyes"
                                        [value]="appointmentfixedby">
                                        {{appointmentfixedby}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-33">
                            <mat-form-field appearance="fill">

                                <mat-label>Visit To Department</mat-label>
                                <mat-select panelClass="custom-select-panel" required formControlName="department_id"
                                    [(ngModel)]="appointment.department_id">
                                    <mat-option *ngFor="let department of departments | async"
                                        value={{department.ref_no}}>
                                        {{department.department_name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-33">
                            <mat-form-field appearance="fill">

                                <mat-label>Whom To Meet</mat-label>
                                <mat-select panelClass="custom-select-panel" required formControlName="whomto_meet"
                                    [(ngModel)]="appointment.whomto_meet">
                                    <mat-option *ngFor="let emplyee of employees | async" value={{emplyee.ref_no}}>
                                        {{emplyee.employee_name}}
                                    </mat-option>
                                </mat-select>

                            </mat-form-field>
                        </mat-card>
                    </div>
                    <div class="flex-row">
                        <mat-card appearance="outlined" class="contain_card flex-33">
                            <mat-form-field appearance="fill" id="selectOption">

                                <mat-label>Appointment Type</mat-label>
                                <mat-select panelClass="custom-select-panel" formControlName="appointment_type" required
                                    [(ngModel)]="appointment.appointment_type">
                                    <mat-option *ngFor="let appointmenttype of appointmentTypes"
                                        [value]="appointmenttype">
                                        {{appointmenttype}}</mat-option>
                                </mat-select>
                            </mat-form-field>


                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-66">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Purpose Details</mat-label>
                                <input class="global-input" matInput required [(ngModel)]="appointment.purpose" formControlName="purpose" />
                            </mat-form-field>
                        </mat-card>
                    </div>
                    <div class="flex-row">
                        <mat-card appearance="outlined" class="contain_card flex-24">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Appointment From Date</mat-label>
                                <input class="global-input" matInput [matDatepicker]="picker1" value="{{appointment.schedule_date_from}}"
                                    (dateChange)="addEventScheduleDateFrom($event)">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">


                                <mat-label>Appointment From Time</mat-label>

                                <input class="global-input" matInput [format]="24" [ngxMatTimepicker]="autoPicker_1"
                                    formControlName="timeCtrl_1" (timeSet)="addEventScheduleTimeFrom($event)">

                                <ngx-mat-timepicker-toggle matSuffix [for]="autoPicker_1">
                                </ngx-mat-timepicker-toggle>

                                <ngx-mat-timepicker #autoPicker_1 mode="dropdown" touchUi="false"
                                    panelClass="timepicker-dropdown-panel">
                                </ngx-mat-timepicker>

                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-24">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Appointment To Date</mat-label>
                                <input class="global-input" matInput [matDatepicker]="picker2" value="{{appointment.schedule_date_to}}"
                                    (dateChange)="addEventScheduleDateTo($event)">
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </mat-card>
                        <mat-card appearance="outlined" class="contain_card flex-25">
                            <mat-form-field appearance="fill" class="field-full-width">


                                <mat-label>Appointment To Time</mat-label>

                                <input class="global-input" matInput [format]="24" [ngxMatTimepicker]="autoPicker_2"
                                    formControlName="timeCtrl_2" (timeSet)="addEventScheduleTimeTo($event)">

                                <ngx-mat-timepicker-toggle matSuffix [for]="autoPicker_2">
                                </ngx-mat-timepicker-toggle>

                                <ngx-mat-timepicker #autoPicker_2 mode="dropdown" touchUi="false"
                                    panelClass="timepicker-dropdown-panel">
                                </ngx-mat-timepicker>

                            </mat-form-field>
                        </mat-card>
                    </div>
                </fieldset>
            </mat-card>
            <mat-card-actions style="min-width: 120px; float: right;">
                <button class="global-button" id="btnn">Save Appointment</button>

            </mat-card-actions>
        </form>
    </mat-tab>

    <!--////////////////////VIEW APPOINTMENT ////////////////////////-->

    <mat-tab label="VIEW" class="tab_content" *ngIf="persistenceService.get('viewDisable') == 'true'">
        <div class="view_div" *ngIf="viewDataAvail">
            <mat-card appearance="outlined" class="view_card">
                <table mat-table [dataSource]="appointmentList" class="mat-elevation-z8">
                    <!-- Appointment Type-->
                    <ng-container matColumnDef="appointment_type">
                        <th mat-header-cell *matHeaderCellDef>App. Type</th>
                        <td mat-cell *matCellDef="let element"> {{element.appointment_type}} </td>
                    </ng-container>
                    <!-- Visitor Name-->
                    <ng-container matColumnDef="visitor_name">
                        <th mat-header-cell *matHeaderCellDef>Visitor Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_name}} </td>
                    </ng-container>
                    <!-- From Company-->
                    <ng-container matColumnDef="visitor_company">
                        <th mat-header-cell *matHeaderCellDef>From Company</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_company}} </td>
                    </ng-container>
                    <!-- Fixed By-->
                    <ng-container matColumnDef="appointment_fixed_by">
                        <th mat-header-cell *matHeaderCellDef>App. Fixed By </th>
                        <td mat-cell *matCellDef="let element"> {{element.appointment_fixed_by}} </td>
                    </ng-container>
                    <!-- Whom To Meet-->
                    <ng-container matColumnDef="whomto_meet">
                        <th mat-header-cell *matHeaderCellDef>Meet To </th>
                        <td mat-cell *matCellDef="let element">{{element.whomto_meet}} </td>
                    </ng-container>
                    <!-- Purpose-->
                    <ng-container matColumnDef="purpose">
                        <th mat-header-cell *matHeaderCellDef>Purpose</th>
                        <td mat-cell *matCellDef="let element"> {{element.purpose}} </td>
                    </ng-container>
                    <!-- Date-->
                    <ng-container matColumnDef="schedule_date_from">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_date_from}} </td>
                    </ng-container>
                    <!-- Time-->
                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef>Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_time_from}} -
                            {{element.schedule_time_to}} </td>
                    </ng-container>

                    <!-- Visitor Name-->
                    <ng-container matColumnDef="schedule_time_to">
                        <th mat-header-cell *matHeaderCellDef>To Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_time_to}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="viewtableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: viewtableColumns;"></tr>
                </table>
            </mat-card>
        </div>
    </mat-tab>

    <!--////////////////////EDIT APPOINTMENT ////////////////////////-->

    <mat-tab label="EDIT" class="tab_content" *ngIf="persistenceService.get('editviewDisable') == 'true'">
        <div class="head_div" class="flex-row">
            <mat-card appearance="outlined" class="company_card" class="flex-50">
                <mat-form-field appearance="fill">

                    <mat-label>Company</mat-label>
                    <input class="global-input" matInput required readonly value="{{defaultCompany}}" formControlName="company_id" />
                </mat-form-field>
            </mat-card>
            <mat-card appearance="outlined" class="company_card" class="flex-50">
                <mat-form-field appearance="fill" class="selectOption">

                    <mat-label>Select Appointment No</mat-label>
                    <mat-select panelClass="custom-select-panel" (selectionChange)="onEditAppointmentSelect($event.value)">
                        <mat-option *ngFor="let appointment of appointmentList"
                            value={{appointment.ref_no}}>{{appointment.ref_no}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-card>
        </div>

        <!-- EDIT FORM BEGIN-->

        <form class="global-form" (ngSubmit)="saveEditAppointment($event)" [formGroup]="editForm">
            <div class="view_div" *ngIf="viewDataAvail">
                <mat-card appearance="outlined" class="mat_card">
                    <fieldset class="field_set">
                        <legend class="legend">Appointment Booking Date & Time</legend>
                        <div class="flex-row">
                            <mat-card appearance="outlined" class="company_card" class="flex-25">
                                <mat-form-field appearance="fill">

                                    <mat-label>Company</mat-label>
                                    <input class="global-input" matInput required readonly value="{{defaultCompany}}"
                                        formControlName="company_id" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="company_card" class="flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Appointment Ref. Date</mat-label>
                                    <input class="global-input" matInput required readonly value="{{editAppointment.ref_no}}"
                                        [disabled]="true" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Booking Date</mat-label>
                                    <input class="global-input" matInput required readonly value="{{editAppointment.booked_on_date}}"
                                        [disabled]="true" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Booking Time</mat-label>
                                    <input class="global-input" matInput required readonly value="{{editAppointment.booked_at_time}}"
                                        [disabled]="true" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </fieldset>
                </mat-card>
                <mat-card appearance="outlined" class="mat_card">
                    <fieldset class="field_set">
                        <legend class="legend">Visitor Details</legend>
                        <div class="flex-row">
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Visitor Name</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.visitor_name"
                                        formControlName="visitor_name" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Company Name</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.visitor_company"
                                        formControlName="visitor_company" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Address</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.address"
                                        formControlName="address" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Visitor Mobile No</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.visitor_mobile_no"
                                        formControlName="visitor_mobile_no" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="flex-row">
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Country</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.country"
                                        formControlName="country" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>State</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.state"
                                        formControlName="state" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>City</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.city"
                                        formControlName="city" />
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>PIN</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.pin" formControlName="pin" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </fieldset>
                </mat-card>
                <mat-card appearance="outlined" class="mat_card">
                    <fieldset class="field_set">
                        <legend class="legend">Appointment Details</legend>
                        <div class="flex-row">
                            <mat-card appearance="outlined" class="contain_card flex-33">
                                <mat-form-field appearance="fill" id="selectOption">

                                    <mat-label>Appointment Fixed By</mat-label>
                                    <mat-select panelClass="custom-select-panel" formControlName="appointment_fixed_by" required
                                        [(ngModel)]="editAppointment.appointment_fixed_by">
                                        <mat-option *ngFor="let appointmentfixedby of appointmentfixedbyes"
                                            [value]="appointmentfixedby">
                                            {{appointmentfixedby}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-33">
                                <mat-form-field appearance="fill">

                                    <mat-label>Visit To Department</mat-label>
                                    <mat-select panelClass="custom-select-panel" required formControlName="department_id" [(value)]="defEditDepartment"
                                        (selectionChange)="onEditDepartmentSelect($event.value)">
                                        <mat-option *ngFor="let dep of departments | async" value={{dep.ref_no}}>
                                            {{dep.department_name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-33">
                                <mat-form-field appearance="fill">

                                    <mat-label>Whom To Meet</mat-label>
                                    <mat-select panelClass="custom-select-panel" required formControlName="whomto_meet"
                                        [(ngModel)]="editAppointment.whomto_meet">
                                        <mat-option *ngFor="let emplyee of employees | async" value={{emplyee.ref_no}}>
                                            {{emplyee.employee_name}}
                                        </mat-option>
                                    </mat-select>

                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="flex-row">
                            <mat-card appearance="outlined" class="contain_card flex-33">
                                <mat-form-field appearance="fill" id="selectOption">

                                    <mat-label>Appointment Type</mat-label>
                                    <mat-select panelClass="custom-select-panel" formControlName="appointment_type" required
                                        [(ngModel)]="editAppointment.appointment_type">
                                        <mat-option *ngFor="let appointmenttype of appointmentTypes"
                                            [value]="appointmenttype">
                                            {{appointmenttype}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-66">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Purpose Details</mat-label>
                                    <input class="global-input" matInput required [(ngModel)]="editAppointment.purpose"
                                        formControlName="purpose" />
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="flex-row">
                            <mat-card appearance="outlined" class="contain_card flex-24">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Appointment From Date</mat-label>
                                    <input class="global-input" matInput [matDatepicker]="picker1"
                                        value="{{editAppointment.schedule_date_from}}"
                                        (dateChange)="addEventScheduleDateFrom($event)">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">


                                    <mat-label>Appointment From Time</mat-label>

                                    <input class="global-input" matInput [format]="24" [ngxMatTimepicker]="autoPicker_3"
                                        formControlName="timeCtrl_3" (timeSet)="addEventScheduleTimeFrom($event)">

                                    <ngx-mat-timepicker-toggle matSuffix [for]="autoPicker_3">
                                    </ngx-mat-timepicker-toggle>

                                    <ngx-mat-timepicker #autoPicker_3 mode="dropdown" touchUi="false"
                                        panelClass="timepicker-dropdown-panel">
                                    </ngx-mat-timepicker>

                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-24">
                                <mat-form-field appearance="fill" class="field-full-width">

                                    <mat-label>Appointment To Date</mat-label>
                                    <input class="global-input" matInput [matDatepicker]="picker2"
                                        value="{{editAppointment.schedule_date_to}}"
                                        (dateChange)="addEventScheduleDateTo($event)">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                            </mat-card>
                            <mat-card appearance="outlined" class="contain_card flex-25">
                                <mat-form-field appearance="fill" class="field-full-width">


                                    <mat-label>Appointment To Time</mat-label>

                                    <input class="global-input" matInput [format]="24" [ngxMatTimepicker]="autoPicker_4"
                                        formControlName="timeCtrl_4" (timeSet)="addEventScheduleTimeTo($event)">

                                    <ngx-mat-timepicker-toggle matSuffix [for]="autoPicker_4">
                                    </ngx-mat-timepicker-toggle>

                                    <ngx-mat-timepicker #autoPicker_4 mode="dropdown" touchUi="false"
                                        panelClass="timepicker-dropdown-panel">
                                    </ngx-mat-timepicker>

                                </mat-form-field>
                            </mat-card>
                        </div>
                    </fieldset>
                </mat-card>
            </div>
            <div class="view_div" *ngIf="viewDataAvail">
                <mat-card-actions style="min-width: 120px; float: right;">
                    <button class="global-button" id="btn1">Edit Appointment</button>
                </mat-card-actions>
            </div>
        </form>
    </mat-tab>

    <!--////////////////////DELETE APPOINTMENT ////////////////////////-->

    <mat-tab label="DELETE" class="tab_content" *ngIf="persistenceService.get('cancelDisable') == 'true'">
        <div class="view_div" *ngIf="viewDataAvail">
            <mat-card appearance="outlined" class="view_card">
                <table mat-table [dataSource]="appointmentList" class="mat-elevation-z8">
                    <!-- Date-->
                    <ng-container matColumnDef="ref_no">
                        <th mat-header-cell *matHeaderCellDef>Ref No.</th>
                        <td mat-cell *matCellDef="let element"> {{element.ref_no}} </td>
                    </ng-container>
                    <!-- Appointment Type-->
                    <ng-container matColumnDef="appointment_type">
                        <th mat-header-cell *matHeaderCellDef>App. Type</th>
                        <td mat-cell *matCellDef="let element"> {{element.appointment_type}} </td>
                    </ng-container>
                    <!-- Visitor Name-->
                    <ng-container matColumnDef="visitor_name">
                        <th mat-header-cell *matHeaderCellDef>Visitor Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_name}} </td>
                    </ng-container>
                    <!-- From Company-->
                    <ng-container matColumnDef="visitor_company">
                        <th mat-header-cell *matHeaderCellDef>From Company</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_company}} </td>
                    </ng-container>
                    <!-- Fixed By-->
                    <ng-container matColumnDef="appointment_fixed_by">
                        <th mat-header-cell *matHeaderCellDef>App. Fixed By </th>
                        <td mat-cell *matCellDef="let element"> {{element.appointment_fixed_by}} </td>
                    </ng-container>
                    <!-- Whom To Meet-->
                    <ng-container matColumnDef="whomto_meet">
                        <th mat-header-cell *matHeaderCellDef>Meet To </th>
                        <td mat-cell *matCellDef="let element">{{element.whomto_meet}} </td>
                    </ng-container>
                    <!-- Purpose-->
                    <ng-container matColumnDef="purpose">
                        <th mat-header-cell *matHeaderCellDef>Purpose</th>
                        <td mat-cell *matCellDef="let element"> {{element.purpose}} </td>
                    </ng-container>
                    <!-- Date-->
                    <ng-container matColumnDef="schedule_date_from">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_date_from}} </td>
                    </ng-container>
                    <!-- Time-->
                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef>Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_time_from}} -
                            {{element.schedule_time_to}} </td>
                    </ng-container>

                    <!-- Visitor Name-->
                    <ng-container matColumnDef="schedule_time_to">
                        <th mat-header-cell *matHeaderCellDef>To Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_time_to}} </td>
                    </ng-container>
                    <ng-container matColumnDef="cancel">
                        <th mat-header-cell *matHeaderCellDef> Cancel </th>
                        <td mat-cell *matCellDef="let element" (click)="onCancelAppointmentClick(element.ref_no)">
                            <i class="material-icons" style="cursor: pointer;">
                                cancel
                            </i>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="deletetableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: deletetableColumns;"></tr>
                </table>
            </mat-card>
        </div>
    </mat-tab>
</mat-tab-group>